// @flow
import Resource from 'speed-js-core/src/api/Resource';

export default class ServiceRequestAccessResource extends Resource {
    basePath: string = 'services/requestAccess/';

    objectPath: string = 'services/requestAccess/{ident}/';
}
